import uuid from "uuid";
import _ from 'lodash';

import {pnpolyArray} from "../../../../../lib/pnpoly";
import {
  getParallelPoints,
  getPointBetweenPoints, getPointOnTheLine, isInnerCorner,
  measureDistanceToInches
} from "../../../../../helpers/sqftHelper";
import sqftConfig from "../../../store/sqftConfig";
import store from "../../../../../../../store";
import {deleteResourceAttachedTo} from "../../../../../../../actions/sqftResourceFunctions";
import {RESOURCE_TYPE} from "../../../../../constants";

export default class LineCorner {

  line;
  id;
  _state = {
    mouseDown: false,
    isHovering: false,
    isCornerLineHovering: false,
    withEdge: false,
    withBacksplash: false,
    withWall: false,
    withId: null,
    backsplashHeight: null,
  };
  attachedShape = null;
  design = {
    additionalOutlineHoverWidth: 3,
  };

  constructor(line) {
    this.line = line;
    this.id = uuid.v4(); //line.id;
  }

  get state() {
    return this._state;
  }

  set state(value) {
    this._state = value;
  }

  getAttachedShape() {
    return this.attachedShape;
  }

  getAttachedItems() {
    let isAnyItemsAttached = false;
    for (const attachedItemKey in this._state.attachedItems) {
      if (this._state.attachedItems[attachedItemKey]) {
        isAnyItemsAttached = true
      }
    }
    return this._state.withEdge
      || this._state.withBacksplash
      || this._state.withWall
      || this._state.withId
      || isAnyItemsAttached
  }

  deleteAttachedItem = () => {
    this.state.withEdge = false;
    this.state.withBacksplash = false;
    this.state.withWall = false;
    this.state.withId = null;
    this.state.attachedShape = null;
    store.dispatch(deleteResourceAttachedTo(RESOURCE_TYPE.attachedToLine, this));
    //this.state.overlay.removeLineText(); // todo
  };

  getLength(){
    return this.line.to.angle
  }

  getLineLength() {
    return this.line.addDecimalToLength(measureDistanceToInches(this.line.to.angle));
  }

  getLineLengthMm() {
    return measureDistanceToInches(this.line.to.angle).millimeters;
  }

  getParent() {
    return this.line.getParent()
  }

  addEdgeToCornerLine = (edgeName, id) => {
    this.state.withEdge = true;
    this.state.withBacksplash = false;
    this.state.withWall = false;
    this.state.withId = id;

    //self.overlay.renderEdgeText(edgeName); //todo
  };

  addBacksplashToCornerLine = (backsplashName, type, featureId, backsplashHeight) => {
    if (type === "wall") {
      this.state.withWall = true;
      this.state.withBacksplash = false;
    } else {
      this.state.withBacksplash = true;
      this.state.withWall = false;
    }
    this.state.withEdge = false;
    this.state.withId = featureId;
    this.state.backsplashHeight = backsplashHeight;
    //self.overlay.renderBacksplashText(backsplashName, type); //todo
  };

  updateCornerHoverState(mousePos){
    this.state.isHovering = false;
    this.state.isCornerLineHovering = false;

    if(this.line.to.angle > 0 && this.isMouseOverAngle(mousePos)) {
      //console.log('mouse over outline angle');
      this.state.isHovering = true;
    }

    if(this.line.to.angle > 0 && this.isMouseOverCornerLine(mousePos)) {
      //console.log('mouse over angle purple line');
      this.state.isCornerLineHovering = true;
    }
  }

  export() {
    return {
      id: this.id,
      _state: _.clone(this._state),
    }
  }

  import(data) {
    this.id = data.id;
    this._state = data._state;
  }

  isMouseOverAngle(mousePos) {
    //console.log('state.angleLinePoints', state.angleLinePoints);
    let field = this.getOutlineAngleLineField();
    let isHovering = pnpolyArray(field, mousePos)
      || pnpolyArray([field[0], field[2], field[1], field[3]], mousePos);

    return isHovering || this.state.mouseDown;
  }

  isMouseOverCornerLine(mousePos) {
    let field = this.getAngleLineField();
    let isHovering = pnpolyArray(field, mousePos)
      || pnpolyArray([field[0], field[2], field[1], field[3]], mousePos);

    return isHovering || this.state.mouseDown ;
  }

  getAngleLineField() {
    const angleLinePoints = this.getAnglePoints();
    const design          = this.line.getDesign();
    let lineField;

    if( angleLinePoints.cordCornerFrom === undefined ) {
      return {}
    }

    let outlineMargin = design.outlineWidth + this.design.additionalOutlineHoverWidth;

    //  line /
    if(angleLinePoints.cordCornerFrom.y < angleLinePoints.cordCornerTo.y && angleLinePoints.cordCornerFrom.x > angleLinePoints.cordCornerTo.x
      || angleLinePoints.cordCornerFrom.y > angleLinePoints.cordCornerTo.y && angleLinePoints.cordCornerFrom.x < angleLinePoints.cordCornerTo.x
    ){
      lineField = [
        [angleLinePoints.cordCornerFrom.x + outlineMargin, angleLinePoints.cordCornerFrom.y + outlineMargin],
        [angleLinePoints.cordCornerTo.x + outlineMargin, angleLinePoints.cordCornerTo.y + outlineMargin],
        [angleLinePoints.cordCornerFrom.x - outlineMargin, angleLinePoints.cordCornerFrom.y - outlineMargin],
        [angleLinePoints.cordCornerTo.x - outlineMargin, angleLinePoints.cordCornerTo.y - outlineMargin],
      ];
    // line \
    } else {
      lineField = [
        [angleLinePoints.cordCornerTo.x + outlineMargin, angleLinePoints.cordCornerTo.y - outlineMargin],
        [angleLinePoints.cordCornerFrom.x + outlineMargin, angleLinePoints.cordCornerFrom.y - outlineMargin],
        [angleLinePoints.cordCornerTo.x - outlineMargin, angleLinePoints.cordCornerTo.y + outlineMargin],
        [angleLinePoints.cordCornerFrom.x - outlineMargin, angleLinePoints.cordCornerFrom.y + outlineMargin],
      ];
    }

    return lineField
  }

  getOutlineAngleLineField() {
    const angleLinePoints = this.getAnglePoints();
    const design          = this.line.getDesign();
    let lineField;

    if( angleLinePoints.cord1 === undefined ) {
      return {}
    }

    let outlineMargin = design.outlineWidth + this.design.additionalOutlineHoverWidth;

    //  line /
    if(angleLinePoints.cord2.y < angleLinePoints.cord3.y && angleLinePoints.cord2.x > angleLinePoints.cord3.x
      || angleLinePoints.cord2.y > angleLinePoints.cord3.y && angleLinePoints.cord2.x < angleLinePoints.cord3.x
    ){
      lineField = [
        [angleLinePoints.cord2.x + outlineMargin, angleLinePoints.cord2.y + outlineMargin],
        [angleLinePoints.cord3.x + outlineMargin, angleLinePoints.cord3.y + outlineMargin],
        [angleLinePoints.cord2.x - outlineMargin, angleLinePoints.cord2.y - outlineMargin],
        [angleLinePoints.cord3.x - outlineMargin, angleLinePoints.cord3.y - outlineMargin],
      ];
    // line \
    } else {
      lineField = [
        [angleLinePoints.cord3.x + outlineMargin, angleLinePoints.cord3.y - outlineMargin],
        [angleLinePoints.cord2.x + outlineMargin, angleLinePoints.cord2.y - outlineMargin],
        [angleLinePoints.cord3.x - outlineMargin, angleLinePoints.cord3.y + outlineMargin],
        [angleLinePoints.cord2.x - outlineMargin, angleLinePoints.cord2.y + outlineMargin],
      ];
    }

    return lineField
  }

  getAnglePoints() {
    const lineDirection = this.line.getParent().getAngleDirection(this.line),
      renderTo = this.line.calculateRenderPosition(this.line.to),
      renderFrom = this.line.calculateRenderPosition(this.line.from),
      nextLine = this.line.getParent().getNextLine(this.line),
      nextLineRenderTo = nextLine.calculateRenderPosition(nextLine.to),
      design = this.line.getDesign();

    let angleLinePoints = {};

    switch (lineDirection.orientation) {
      case "horizontal":
      case "vertical":
      case "NORTHWEST":
      case "NORTHEAST":
      case "SOUTHWEST":
      case "SOUTHEAST": {
        nextLine.setLinePoints();
        if (this.line.drawLineTo === undefined || this.line.drawLineFrom === undefined) {
          this.line.setLinePoints();
        }

        const cord1 = this.line.drawLineTo;
        const cord4 = getPointOnTheLine(nextLine.drawLineFrom, nextLine.drawLineTo, design.outlineMargin); // +design.outlineMargin is to prevent overlapping

        // purple corner line
        // const renderTo = this.line.calculateRenderPosition(this.line.to);
        // const renderFrom = this.line.calculateRenderPosition(this.line.from);
        // const radiusMultiplier = Math.sqrt( Math.pow(this.getLength(), 2) * 2) * sqftConfig.scale;
        // const nextLineRenderTo = this.line.calculateRenderPosition(nextLine.to);

        const radiusMultiplier = Math.sqrt( Math.pow(this.line.to.angle, 2) * 2);
        const radius = radiusMultiplier * sqftConfig.scale;
        const isLineCornerInner =  isInnerCorner(this.line.getParent(), renderFrom, renderTo, nextLineRenderTo);
        const pointIndent = isLineCornerInner ? 4 : -4;
        const pointOnTheBlueLine = getPointBetweenPoints(renderTo, renderFrom, radius / 2 + pointIndent);
        const pointOnTheBlueNextLine = getPointBetweenPoints(renderTo, nextLineRenderTo, radius / 2 + pointIndent);
        const [cord2] = getParallelPoints(renderFrom, pointOnTheBlueLine,-design.outlineMargin);
        const [cord3] = getParallelPoints(nextLineRenderTo, pointOnTheBlueNextLine, design.outlineMargin);

        const cordCornerIndent = isLineCornerInner && this.line.to.angle < design.outlineMargin
          ? 0
          : -3;
        const cordCornerFrom = getPointOnTheLine(cord2, cord3, cordCornerIndent * sqftConfig.scale); // set offset from corner
        const cordCornerTo = getPointOnTheLine(cord3, cord2, cordCornerIndent * sqftConfig.scale); // set offset from corner
        // v2
        //let [cordCornerTo, cordCornerFrom] = getParallelPoints(pointOnTheBlueLine, pointOnTheBlueNextLine, -9);

        angleLinePoints = {
          cord1: {
            x: cord1.x,
            y: cord1.y
          },
          cord2: {
            x: cord2.x,
            y: cord2.y
          },
          cord3: {
            x: cord3.x,
            y: cord3.y
          },
          cord4: {
            x: cord4.x,
            y: cord4.y
          },
          cordCornerFrom: {
            x: cordCornerFrom.x,
            y: cordCornerFrom.y
          },
          cordCornerTo: {
            x: cordCornerTo.x,
            y: cordCornerTo.y
          }
        };
        break;
      }
      default:
        break;
    }
    //wtf?
    angleLinePoints.cord2.width = sqftConfig.fieldWidth;
    angleLinePoints.cord3.width = sqftConfig.fieldWidth;
    angleLinePoints.cord2.height = sqftConfig.fieldWidth;
    angleLinePoints.cord3.height = sqftConfig.fieldWidth;

    return angleLinePoints;
  }
}
